import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--bg-secondary);
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  animation: tracking-in-expand 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) both;
`;

